<template>
  <div v-if="onlyValue" :class="{'show-txt-rest':readonly,'blur-border': visible,'visible-onlyValue': currentValue && currentValue.realname}" class="table-select-box">
    <el-popover placement="bottom" width="314" trigger="click" v-model="visible" :disabled="readonly" @show="popoverShow">
      <MemberList v-loading="loading" :projectId="projectId" :parentId="parentId" :visible.sync="visible" @changeCheckout="changeCheckout" :uid="currentValue.uid" :memberList="memberList" @showAll="showAll" :isHasPermission="isHasPermission"></MemberList>
      <div slot="reference">
        <div v-if="currentValue.realname">
          <Myavatar width="28px" height="28px" style="margin-right: 10px;" :imgUrl="currentValue.user_avatar" :userName="currentValue.realname"><span v-if="!isTasksRight" style="font-size: 14px;">{{currentValue.realname}}</span></Myavatar>
          <div class="close-icon">
            <i class="el-icon-circle-close" v-if="!readonly && !onlyValue" @click="clearChekc"></i>
          </div>
        </div>
        <p v-else class="table-select-button">
          <span v-if="readonly && !isTasksRight">暂无</span>
          <img class="not-man" v-else-if="isTasksRight" src="image/executor.png" alt="">
          <span v-else ><i class="el-icon-circle-plus"></i>添加</span>
        </p>
      </div>
    </el-popover>
  </div>
  <div class="Executor" :class="{'hover-style-rest':readonly}" v-else>
    <el-popover placement="bottom" width="314" trigger="click" v-model="visible" :disabled="readonly || isTemplate" @show="popoverShow">
      <MemberList v-loading="loading" :projectId="projectId" :parentId="parentId" :visible.sync="visible" @changeCheckout="changeCheckout" :uid="currentValue.uid" :memberList="memberList" @showAll="showAll" :isHasPermission="isHasPermission"></MemberList>
      <div slot="reference">
        <div class="hover-style" v-if="currentValue.realname">
          <div class="executor" v-show="currentValue.realname">
            <Myavatar width="28px" height="28px" style="margin-right: 10px;" :imgUrl="currentValue.user_avatar" :userName="currentValue.realname"><span style="font-size: 14px;">{{!onlyValue ? currentValue.realname : ''}}</span></Myavatar>
            <div class="close-icon">
              <i class="el-icon-circle-close" v-if="!readonly && !onlyValue" @click="clearChekc"></i>
            </div>
          </div>
        </div>
        <img class="not-man" v-else-if="onlyValue && !readonly" src="image/executor.png" alt="">
        <div v-else>
          <span class="add-txt" :class="{ readonly, 'disabled': isTemplate }">{{readonly ? '暂无' : '添加'}}</span>
        </div>
      </div>
    </el-popover>
  </div>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex';
import MemberList from "./memberList"
export default {
  name: "Executor",
  props: ['value', 'config', 'defaultValue', 'projectId', 'onlyValue', 'parentId', 'readonly', 'user_in_parent_tasks_permission', 'isTasksRight', 'isTemplate'],
  components: {
    MemberList
  },
  data() {
    return {
      visible: false,
      form: {},
      rules: {},
      loading: false,
      checkedData: {
        uid: null,
        realname: ''
      },
      uid: '',
      taskMemberlist: [],
      memberList: []
    }
  },
  computed: {
    ...mapState('task/task', {
      newMember: state => {
        let arr = []
        state.member.map(res => {
          arr.push(...res.children)
        })

        return arr
      }
    }),
    ...mapState('project/project', {
      projectMember: state => {
        let arr = []
        state.newMember.map(res => {
          arr.push(...res.children)
        })
        return arr
      },
      isAdmin: state => state.isAdmin
    }),
    ...mapState('layout/layout', {
      userInfo: state => state.userInfo
    }),
    currentValue: {
      get: function () {
        if (!this.value) {
          return {}
        }
        return this.value
      },
      set: function (newValue) {
        this.$emit('input', newValue)
      }
    },
    isHasPermission() {
      return this.isBoss || this.isAdmin || this.user_in_parent_tasks_permission
    }
  },
  // created() {
  //   console.log('aaaaaaaaaaaa')
  // },
  methods: {
    ...mapActions('task/task', ['editTask', 'getTaskMember']),
    popoverShow() {
      this.getTaskMemberTemp()
    },
    opend() {
      this.visible = true
    },
    getDefaultValue(val) {
      return val ? val.uid : ''
    },
    getMessage(res) {
      return `<span class="message-mixin-tip">将${res.field_name}修改为</span><span class="message-mixin-task">[${res.new_data}]</span>`
    },
    changeCheckout(data) {
      this.$emit('changeRunMan', data)
      this.$emit('input', data)
      this.$nextTick(() => {
        this.$emit('change')
      })
    },
    showAll() { // 显示算有成员（项目成员）
      if (this.isHasPermission) {
        const diff = this.projectMember.filter(item => !(this.memberList.find(res => res.uid === item.uid)));
        this.memberList.push(...diff)
      }
    },
    async getTaskMemberTemp() {
      this.loading = true
      if (!this.parentId) { // 判断是否为子任务
        this.taskMemberlist = JSON.parse(JSON.stringify(this.projectMember)) // 不是子任务选项为项目成员
      } else {
        await this.getTaskMember({ task_id: this.parentId }).then(() => { // 上一级任务参与人
          this.taskMemberlist = JSON.parse(JSON.stringify(this.newMember))
        })
      }
      this.getCanUse()
      this.loading = false
    },
    getCanUse() { // 权限可指派
      if (this.isHasPermission) { // 老大、管理员或者为子任务和我创建的项目
        this.memberList = JSON.parse(JSON.stringify(this.taskMemberlist))
      } else {
        let obj = this.taskMemberlist.find(res => res.uid == this.userInfo.uid) // 反之只能指派给自己
        this.memberList = obj ? JSON.parse(JSON.stringify([obj])) : []
      } // 其他原因不在项目成员里
    },
    getProjectMembers() {
      return api.getProjectMembers({ project_id: this.projectId }).then(res => {
        this.dataset = []
        this.oldMemeberList = []
        res.forEach(res => {
          for (let key in res) {
            this.oldMemeberList.push(...res[key])
            this.dataset.push({
              name: key,
              data: res[key],
            })
          }
        })
      })
    },
    tileData(dataList) {
      let arr = [];
      dataList.forEach(item => {
        arr = [...arr, ...item.member];
      });
      return arr;
    },
    clearChekc() {
      this.$emit('input', '')
      this.$nextTick(() => {
        this.$emit('change')
      })
    }
  },
}
</script>

<style lang="scss" scoped>
.Executor {
  display: inline-block;
  cursor: pointer;
  .close-icon {
    display: flex;
    align-items: center;
  }
  .executor {
    font-size: 12px;
    display: flex;
    height: 40px;
    .show-txt {
      padding: 0;
    }
    .clear-box {
      width: 16px;
      height: 16px;
      border-radius: 50%;
    }
  }
  .executor .avatar-box {
    margin-right: 6px;
  }
  .executor .iconicon_enlarge {
    margin-left: 5px;
  }
}
.not-man {
  width: 28px;
  height: 28px;
  box-sizing: border-box;
  border-radius: 50%;
  margin-top: -1px;
}
</style>
